import { TFunction } from 'i18next';

/** What tells a farmer's wallets in one subwallet apart: their expiry, or that they hold a reserve. */
export const walletDetail = (
  wallet: {
    bookingExternalId: string | null,
    expirationDate: string | null,
    isBookingReserve: boolean,
  },
  t: TFunction,
): string | null => {
  if (wallet.isBookingReserve) {
    return wallet.bookingExternalId
      ? t($ => $.pointsAudit.revert.walletBookingReserveFor, { booking: wallet.bookingExternalId })
      : t($ => $.pointsAudit.revert.walletBookingReserve);
  }
  if (wallet.expirationDate) {
    return t($ => $.pointsAudit.revert.walletExpiring, { date: wallet.expirationDate });
  }
  return null;
};
